import React, { FunctionComponent, useContext, useEffect } from "react";
import { AppPage, LoggedOutFooter } from "../../components";
import { useTranslate, useYearInTitle } from "../../helpers";
import { AppStore } from "../../app/store";
import WhatMedicareCoverage from "./WhatMedicareCoverage";
import routes from "../../app/routes";
import { Redirect, withRouter, RouteComponentProps } from "react-router";
import { createGa4Event, Ga4Event } from "../../helpers/analytics";
import { useFlags } from "launchdarkly-react-client-sdk";

const QuestionRoutingPage: FunctionComponent<RouteComponentProps> = () => {
  const t = useTranslate();
  const { state } = useContext(AppStore.AppContext);
  const flags = useFlags();

  useEffect(() => {
    createGa4Event({ event_name: Ga4Event.PLAN_FINDER_STARTED, state, flags });
  }, []);

  // heading is the shown on the page, i.e. <h1>.
  const heading = t("oe_questions.banner.title");
  // title is the page title.
  const title = useYearInTitle(heading, state.year);

  if (state.beneficiary && !state.csr) {
    return <Redirect to={routes.beneLanding} />;
  }

  return (
    <AppPage heading={heading} title={title}>
      <span className="ds-u-visibility--screen-reader">
        {t("sr_only_additional_questions_may_appear")}
      </span>
      <div className="ds-u-margin-bottom--5 PlanPreferencePage">
        <WhatMedicareCoverage />
      </div>
      <LoggedOutFooter />
    </AppPage>
  );
};

export default withRouter(QuestionRoutingPage);
